/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import opacity0 from "./images/opacity-0.png";
import opacity4 from "./images/opacity-4.png";
import opacity8 from "./images/opacity-8.png";
import opacity12 from "./images/opacity-12.png";
import opacity16 from "./images/opacity-16.png";
import opacity24 from "./images/opacity-24.png";
import opacity32 from "./images/opacity-32.png";
import opacity40 from "./images/opacity-40.png";
import opacity48 from "./images/opacity-48.png";
import opacity64 from "./images/opacity-64.png";
import opacity80 from "./images/opacity-80.png";
import opacity1 from "./images/opacity-1.png";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h3: "h3"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Opacity is the degree to which an object or material allows light to pass through it. Use the following tokens to apply transparency to an element."), "\n", React.createElement(_components.h3, {
    id: "opacity-tokens"
  }, "Opacity Tokens"), "\n", React.createElement("br"), "\n", React.createElement("br"), "\n", React.createElement("table", {
    style: {
      width: "100%"
    }
  }, React.createElement("tbody", null, React.createElement("tr", null, React.createElement("th", {
    style: {
      width: "33%",
      textAlign: "left"
    }
  }, "Token"), React.createElement("th", {
    style: {
      width: "33%",
      textAlign: "left"
    }
  }, "Value"), React.createElement("th", {
    style: {
      width: "33%",
      textAlign: "left"
    }
  }, "Example")), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td"), React.createElement("td", null, "0"), React.createElement("td", null, React.createElement("img", {
    src: opacity0,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-1"), React.createElement("td", null, "0.04"), React.createElement("td", null, React.createElement("img", {
    src: opacity4,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-2"), React.createElement("td", null, "0.08"), React.createElement("td", null, React.createElement("img", {
    src: opacity8,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-3"), React.createElement("td", null, "0.12"), React.createElement("td", null, React.createElement("img", {
    src: opacity12,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-4"), React.createElement("td", null, "0.16"), React.createElement("td", null, React.createElement("img", {
    src: opacity16,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-6"), React.createElement("td", null, "0.24"), React.createElement("td", null, React.createElement("img", {
    src: opacity24,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-8"), React.createElement("td", null, "0.32"), React.createElement("td", null, React.createElement("img", {
    src: opacity32,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-10"), React.createElement("td", null, "0.40"), React.createElement("td", null, React.createElement("img", {
    src: opacity40,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-12"), React.createElement("td", null, "0.48"), React.createElement("td", null, React.createElement("img", {
    src: opacity48,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-16"), React.createElement("td", null, "0.64"), React.createElement("td", null, React.createElement("img", {
    src: opacity64,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td", null, "—opacity-20"), React.createElement("td", null, "0.80"), React.createElement("td", null, React.createElement("img", {
    src: opacity80,
    alt: "opacity"
  }))), React.createElement("tr", {
    style: {
      verticalAlign: "top"
    }
  }, React.createElement("td"), React.createElement("td", null, "1"), React.createElement("td", null, React.createElement("img", {
    src: opacity1,
    alt: "opacity"
  }))))), "\n", React.createElement("br"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
